import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { LoadingButton } from '@sorare/core/src/atoms/buttons/LoadingButton';
import { Basket } from '@sorare/core/src/atoms/icons/Basket';
import { BasketBall } from '@sorare/core/src/atoms/icons/BasketBall';
import { Target } from '@sorare/core/src/atoms/icons/Target';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandS, LabelL } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';
import { glossary } from '@sorare/core/src/lib/glossary';

import { QuickPlayTutorialDialogType } from '../types';

const Root = styled(Vertical)`
  justify-self: center;
`;
const SecondaryButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--intermediate-unit);
`;
const ButtonWrapper = styled.div`
  align-self: stretch;
  & > * {
    width: 100%;
  }
`;

type Props = {
  onSelect: (type: QuickPlayTutorialDialogType) => void;
  selectedType: QuickPlayTutorialDialogType;
  onContinue: () => void;
  loading: boolean;
};
export const QuickPlayTutorialFooter = ({
  onSelect,
  selectedType,
  onContinue,
  loading,
}: Props) => {
  return (
    <Root center gap={2}>
      <Chip>
        <BrandS>
          <FormattedMessage
            id="IntroducingQuickPlayDialog.footer"
            defaultMessage="Sorare play book"
          />
        </BrandS>
      </Chip>
      <SecondaryButtonsWrapper>
        {selectedType !== 'targets' && (
          <Button
            color="tertiary"
            size="medium"
            onClick={() => onSelect('targets')}
          >
            <Target />
            <LabelL>
              <FormattedMessage
                id="IntroducingQuickPlayDialog.targets"
                defaultMessage="Targets"
              />
            </LabelL>
          </Button>
        )}
        {selectedType !== 'scoring' && (
          <Button
            color="tertiary"
            size="medium"
            onClick={() => onSelect('scoring')}
          >
            <Basket color="#00F3EB" />
            <LabelL>
              <FormattedMessage
                id="IntroducingQuickPlayDialog.scoring"
                defaultMessage="Scoring"
              />
            </LabelL>
          </Button>
        )}
        {selectedType !== 'quickPlay' && (
          <Button
            color="tertiary"
            size="medium"
            onClick={() => onSelect('quickPlay')}
          >
            <BasketBall
              color={
                <linearGradient
                  x1="10.6667"
                  y1="-4.7187e-08"
                  x2="7.21137"
                  y2="19.452"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0721154" stopColor="#03FFBD" />
                  <stop offset="1" stopColor="#9A45FF" />
                </linearGradient>
              }
            />
            <LabelL>
              <FormattedMessage {...glossary.quickPlay} />
            </LabelL>
          </Button>
        )}
      </SecondaryButtonsWrapper>
      <ButtonWrapper>
        <LoadingButton
          loading={loading}
          size="large"
          color="primary"
          onClick={onContinue}
        >
          <FormattedMessage {...glossary.playNow} />
        </LoadingButton>
      </ButtonWrapper>
    </Root>
  );
};
